import { render, staticRenderFns } from "./prstatushist.vue?vue&type=template&id=5c836cd0&scoped=true"
import script from "./prstatushist.vue?vue&type=script&lang=js"
export * from "./prstatushist.vue?vue&type=script&lang=js"
import style0 from "./prstatushist.vue?vue&type=style&index=0&id=5c836cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c836cd0",
  null
  
)

export default component.exports